<template>
    <b-modal ref="reportModal" size="xl" centered @shown="onShown" @hidden="hide">
        <template #modal-header>
            <div class="modal-header-content">
                <h5 class="modal-title">보고서 관리</h5>
                <div class="modal-header-right">
                    <div class="modal-header-filters">
                        <select
                            :value="effectiveFilterWorkflowIdx"
                            class="form-control form-control-sm filter-select"
                            :disabled="!!workflowIdx"
                            @input="filterWorkflowIdx = $event.target.value === '' ? '' : $event.target.value"
                        >
                            <option
                                v-for="opt in workflowFilterOptions"
                                :key="opt.value === '' ? '_all' : opt.value"
                                :value="opt.value"
                            >
                                {{ opt.text }}
                            </option>
                        </select>
                        <select v-model="filterReportStat" class="form-control form-control-sm filter-select">
                            <option value="">전체 상태</option>
                            <option v-for="opt in reportStatFilterOptions" :key="opt.value" :value="opt.value">
                                {{ opt.text }}
                            </option>
                        </select>
                    </div>
                    <button type="button" class="modal-close-btn" @click="hide">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
        </template>
        <ReportBuilder
            ref="reportBuilder"
            :loginUser="loginUser"
            :filterWorkflowIdx="effectiveFilterWorkflowIdx"
            :filterReportStat="filterReportStat"
            :presetWorkflowIdx="workflowIdx"
            :presetWorkflowName="workflowName"
            @report-generated="handleReportGenerated"
        />
        <template #modal-footer>
            <slot name="footer">
                <b-button variant="secondary" @click="hide">닫기</b-button>
            </slot>
        </template>
    </b-modal>
</template>

<script>
import ReportBuilder from "./ReportBuilder.vue";
import carbonApi from "../../api";
import CarbonCodes from "../../codes";

export default {
    name: "ReportModal",
    components: { ReportBuilder },
    props: {
        loginUser: {
            type: Object,
            default: null,
        },
        workflowIdx: {
            type: Number,
            default: null,
        },
        workflowName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            filterWorkflowIdx: "",
            filterReportStat: "",
            workflows: [],
        };
    },
    computed: {
        effectiveFilterWorkflowIdx() {
            return this.workflowIdx != null ? this.workflowIdx : this.filterWorkflowIdx;
        },
        workflowFilterOptions() {
            const opts = this.workflowIdx == null ? [{ value: "", text: "전체 워크플로우" }] : [];
            this.workflows.forEach((wf) => {
                opts.push({
                    value: wf.workflowIdx,
                    text: `[${this.getPeriodStatText(wf.periodStat)}] ${wf.workflowName || wf.workflowIdx} (${this.formatPeriod(wf.fromMonth)} ~ ${this.formatPeriod(wf.toMonth)})`,
                });
            });
            if (this.workflowIdx != null) {
                const exists = opts.some((o) => o.value === this.workflowIdx);
                if (!exists) {
                    opts.unshift({
                        value: this.workflowIdx,
                        text: this.workflowName || `워크플로우 #${this.workflowIdx}`,
                    });
                }
            }
            return opts;
        },
        reportStatFilterOptions() {
            return CarbonCodes.reportStat.getList();
        },
    },
    methods: {
        show() {
            this.$refs.reportModal.show();
        },
        hide() {
            this.$refs.reportModal.hide();
        },
        onShown() {
            this.loadWorkflows();
            this.$nextTick(() => {
                if (this.$refs.reportBuilder && typeof this.$refs.reportBuilder.initChart === "function") {
                    this.$nextTick(() => {
                        this.$refs.reportBuilder.initChart();
                    });
                }
            });
        },
        async loadWorkflows() {
            try {
                const res = await carbonApi.workflow.getInventoryWorkflows({});
                const data = res.data?.data || res.data;
                const allWorkflows = data?.workflows || data || [];
                const allowedStats = ["VERIFIED", "CONFIRMED"];
                this.workflows = allWorkflows.filter((wf) => allowedStats.includes(wf.periodStat));
            } catch (err) {
                console.error("[ReportModal] 워크플로우 목록 조회 실패:", err);
            }
        },
        getPeriodStatText(stat) {
            return CarbonCodes.periodStat.getLabel(stat) || stat || "-";
        },
        formatPeriod(p) {
            if (!p) return "-";
            const s = String(p);
            if (s.length === 6) return `${s.slice(0, 4)}년 ${s.slice(4)}월`;
            return s;
        },
        handleReportGenerated() {
            this.$emit("report-generated");
        },
    },
};
</script>

<style scoped>
.modal-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 12px;
}

.modal-header-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.modal-header-filters {
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-header-filters .filter-select {
    min-width: 140px;
    font-size: 13px;
}

.modal-title {
    font-size: 18px;
    font-weight: 600;
}

.modal-close-btn {
    font-size: 16px;
    cursor: pointer;
    color: #999999;
    transition: all 0.2s ease;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    &:hover {
        color: #2c2c2c;
        background: #f5f5f5;
    }
    &:focus {
        outline: none;
    }
    &:active {
        transform: scale(0.95);
    }
    &:focus-visible {
        outline: none;
    }
    &:focus-within {
        outline: none;
    }
    &:focus-visible {
        outline: none;
    }
}
</style>
